import React from "react";
import Slider from "react-slick";
import { CardMedia, Card } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { CustomChartsTitle } from "./Custom/CustomTypography";
import { useTranslation } from "react-i18next";

//News props to show title as "News & updates" else "Alerts & updates"
const NewsSection = ({ news, images }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    centerMode: true,
  };
  const { t } = useTranslation();

  const handleView = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div style={{ overflow: "hidden" }}>
      <div style={{ padding: "0px 16px 20px 16px" }}>
        <CustomChartsTitle>
          {news ? t("News & updates") : t("Alerts & updates")}
        </CustomChartsTitle>
      </div>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index}>
            <Card
              style={{
                padding: "0 5px",
                backgroundColor: "transparent",
                boxShadow: "none",
              }}
            >
              <CardMedia
                component="img"
                src={image.image}
                alt={`Image ${index}`}
                sx={{
                  height: "180px",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: "4px",
                }}
                onClick={() => handleView(image.url)}
              />
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default NewsSection;
